<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title=`
      (id && !$route.query.parentId)
        ? "Редактирование альбома"
        : "Добавление альбома"
    `
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          s-publish-date-status(
            :errors='errors'
            :model='model'
          )
        v-flex(xs6)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='model.name'
            label='Название'
          )
        v-flex(xs6)
          s-sites-picker(
            v-model='model.site_id'
          )
        v-flex(xs12)
          v-text-field(
            :error='errors.has("description")'
            :error-messages='errors.first("description")'
            v-model='model.description'
            label='Описание'
          )
        v-flex(xs12)
          div.mb-2
            v-label Галерея
          s-sortable(
            :openable='true'
            :deletable='true'
            :updateServer='true'
            :record-id='model.id'
            v-model='model.files'
          )
          dropzone(v-model='files')
        v-flex(xs4)
          s-auto-image-upload(
            v-model='model.cover'
            :src='model.cover_url'
            :parseResponse='r => r.hash'
            label='Обложка галереи'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  components: {
    Dropzone: () => import('@/components/async/Dropzone')
  },

  data: () => ({
    files: {},
    model: {}
  }),

  async created() {
    if (this.id) {
      this.updateItem()
    }
  },

  methods: {
    async updateItem() {
      if (this.$route.query.parentId) return
      this.model = (await this.fetchSingle({ id: this.id })).data
    },

    async onSave() {
      const { parentId } = this.$route.query
      const files = Object.keys(this.files)

      if (parentId) {
        this.model['parent_id'] = parentId
      }

      if (files.length) {
        this.model['uploaded_files'] = files
      }

      try {
        if (this.id && !parentId) {
          await this.update({
            id: this.id,
            data: this.model
          })
        } else {
          await this.create({
            data: this.model
          })
        }

        this.$root.showSnack('Альбом сохранен')
        this.$router.push({ name: 'Content.Gallery.List' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    ...mapActions('content/gallery', ['fetchSingle', 'update', 'create'])
  },

  computed: mapGetters('content/gallery', ['isLoading'])
}
</script>
